import {ScriptsProvider} from '../providers/scriptsProvider';

class LazyDmcaBadge
{
    static load() {
        let dmcaBadgeMeta = document.querySelector('[data-script="dmca-badge"]');

        if (dmcaBadgeMeta) {
            ScriptsProvider.addWithAttributes('https://images.dmca.com/Badges/DMCABadgeHelper.min.js', {});
        }
    }
}

export {LazyDmcaBadge};
